import React, { useEffect , useState , useContext} from 'react';
import { fetchSaveTravel} from '../../apiCall';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import Context from '../../context/context';
import TopBaner from '../TopBaner/topBaner';
import SideBar from '../SideBar/sideBar';
import Footer from '../Footer/Footer';


function AfterPaymentSaveTravel() {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccessAlert, setIsSuccessAlert] = useState(false); 
  const {state, dispatch} = useContext(Context);

    useEffect(() =>{

      setTimeout(() => {
    console.log(localStorage)
    console.log(localStorage.getItem('invitationData'))
    const invitationData = JSON.parse(localStorage.getItem('invitationData'));
    console.log("invitationData from local storage:)", invitationData);
    handleSaveTravel(invitationData)
    if (isSuccessAlert) {
      const timer = setTimeout(() => {
        setIsSuccessAlert(false);
      }, 3000);
      return () => clearTimeout(timer);
    }  
      }, 2000);
    
    
 }, [isSuccessAlert])

const handleSaveTravel = (invitationData) => {
  setIsLoading(true);
  fetchSaveTravel(invitationData, (data) => {
    console.log("Data handleSaveTravel:", data); 
    setIsLoading(false);
    setIsSuccessAlert(true);
    localStorage.removeItem('invitationData');
    localStorage.setItem('saveTravel' , JSON.stringify(data))
    window.location.href = 'https://pych-customers.web.app/success';
  })
  .catch(error => {

    setIsLoading(false);
    if (error.name === 'TypeError' && error.message === 'Failed to fetch') {
      alert('שגיאה. נכשלה גישה לשרת. אנא לשירות לקוחות.');
    } else {
      alert('שגיאה. הזמנתך לא נקלטה.');
    }
  });
};



  return (
    <div>
      <TopBaner></TopBaner>
      <SideBar></SideBar>
    <div className='paymentCard'>
         <div style={{ position: 'relative' }}>
      {isLoading && (
        <div
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 9999,
            padding: '20px',
            borderRadius: '8px',
          }}
        >
    <CircularProgress sx={{ color: '#3422F2' }} size={200} />
    </div>
      )}
    </div>
    {isSuccessAlert && (
      <Alert style={{ position: 'fixed', top: 200, right: 0, textAlign: 'right'  , margin: '20px'}} onClose={() => {setIsSuccessAlert(false)}}>הנסיעה הוזמנה בהצלחה</Alert>
      )}
      <img style={{ margin: '0' , height :'100px' }} src="pycBlueIogo.png" alt="pycBlueIogo" />
      {/* <div>
      <img style={{ height: '100px', width: '110px', marginRight: '20px' }} src="logo1.png" alt="logo-pych" />
      <img style={{ height: '100px', width: '150px' , marginRight: '20px' }} src="logo2.png" alt="logo-pych" />
      </div> */}
      <p>רק רגע , יוצרים את הנסיעה שלך </p>
      <p>נא לא לסגור את הדף</p>
      <p>המתן לאישור</p>
    </div>
    <Footer></Footer>
    </div>
  );
}

export default AfterPaymentSaveTravel;